"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ts_validators_1 = require("ts-validators");
const valueIsControlsControlEventDefinition = (0, ts_validators_1.buildValueIsShape)('ControlEvent', {
    id: ts_validators_1.valueIsString,
    process: (0, ts_validators_1.buildValueIsOneOf)([
        ts_validators_1.valueIsUndefined,
        (0, ts_validators_1.buildValueIsArrayOf)(ts_validators_1.valueIsString),
    ]),
    type: ts_validators_1.valueIsString,
});
exports.default = valueIsControlsControlEventDefinition;
